define('main.js',['require','Promise','jquery','./blocks/burger/burger','./blocks/request-form/request-form','./blocks/support/support','./blocks/popup/popup'],function (require) {
    'use strict';

    window.gaCategoryPrefix = 'cld-partner';
    require('Promise');
    require('jquery');
    require('./blocks/burger/burger');
    require('./blocks/request-form/request-form');
    require('./blocks/support/support');
    require('./blocks/popup/popup');
});

